// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__14y2I","boxTitle":"Qualiphy_boxTitle__2Dwqr","box":"Qualiphy_box__1eNOj","toggleWrap":"Qualiphy_toggleWrap__1MzA1"};